function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMekoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 248 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-10.3113,-12.3869)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,10.1933,11.7314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.604,15.752L69.345,15.752L46.756,90.872L35.012,90.872L13.455,15.752L13.198,15.752L13.198,90.872L0.226,90.872L0.226,0.776L22.877,0.776L41.463,68.026L41.723,68.026L60.696,0.776L246.614,0.776L246.614,11.042L82.576,11.042L82.576,90.872L69.604,90.872L69.604,15.752Z",
    style: {
      fill: "rgb(0,84,120)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,10.1933,11.7314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.35,21.093L132.803,21.093L132.803,31.225L109.064,31.225L109.064,49.7L131.51,49.7L131.51,59.831L109.064,59.831L109.064,80.29L133.794,80.29L133.794,90.421L96.35,90.421L96.35,21.093Z",
    style: {
      fill: "rgb(0,84,120)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,10.1933,11.7314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.008,21.093L158.72,21.093L158.72,50.495L159.019,50.495L178.783,21.093L193.383,21.093L169.844,53.771L195.27,90.421L179.875,90.421L159.019,57.843L158.72,57.843L158.72,90.421L146.008,90.421L146.008,21.093Z",
    style: {
      fill: "rgb(0,84,120)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,10.1933,11.7314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M220.398,81.68C228.443,81.68 234.898,74.829 234.898,55.757C234.898,36.688 228.443,29.835 220.398,29.835C212.354,29.835 205.896,36.688 205.896,55.757C205.896,74.829 212.354,81.68 220.398,81.68ZM220.398,20.102C234.799,20.102 248.01,30.829 248.01,55.757C248.01,80.687 234.799,91.415 220.398,91.415C205.996,91.415 192.788,80.687 192.788,55.757C192.788,30.829 205.996,20.102 220.398,20.102Z",
    style: {
      fill: "rgb(0,84,120)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,10.1933,11.7314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.455,128.079L4.445,128.079L7.143,121.391L20.139,121.391L22.837,128.079L26.979,128.079L15.769,101.556L11.779,101.556L0.455,128.079ZM18.923,118.276L8.359,118.276L13.641,105.128L18.923,118.276Z",
    style: {
      fill: "rgb(0,84,120)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,10.1933,11.7314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.313,128.079L49.209,128.079L49.209,124.735L38.113,124.735L38.113,101.556L34.313,101.556L34.313,128.079Z",
    style: {
      fill: "rgb(0,84,120)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,10.1933,11.7314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.519,101.556L73.719,101.556L73.719,116.604C73.719,121.695 72.123,125.191 67.221,125.191C62.319,125.191 60.723,121.695 60.723,116.604L60.723,101.556L56.923,101.556L56.923,117.098C56.923,124.545 60.685,128.535 67.221,128.535C73.757,128.535 77.519,124.545 77.519,117.098L77.519,101.556Z",
    style: {
      fill: "rgb(0,84,120)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,10.1933,11.7314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.892,128.079L91.692,128.079L91.692,105.128L91.768,105.128L100.546,128.079L104.27,128.079L113.048,105.128L113.124,105.128L113.124,128.079L116.924,128.079L116.924,101.556L110.654,101.556L102.484,123.595L94.162,101.556L87.892,101.556L87.892,128.079Z",
    style: {
      fill: "rgb(0,84,120)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,10.1933,11.7314)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 127.26,
    y: 101.556,
    width: 3.8,
    height: 26.523,
    style: {
      fill: "rgb(0,84,120)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,10.1933,11.7314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.32,128.079L145.12,128.079L145.12,106.268L145.196,106.268L157.204,128.079L162.068,128.079L162.068,101.556L158.268,101.556L158.268,122.911L158.192,122.911L146.488,101.556L141.32,101.556L141.32,128.079Z",
    style: {
      fill: "rgb(0,84,120)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,10.1933,11.7314)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.327,
    y: 101.556,
    width: 3.8,
    height: 26.523,
    style: {
      fill: "rgb(0,84,120)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,10.1933,11.7314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M207.021,101.556L203.221,101.556L203.221,116.604C203.221,121.695 201.625,125.191 196.723,125.191C191.821,125.191 190.226,121.695 190.226,116.604L190.226,101.556L186.426,101.556L186.426,117.098C186.426,124.545 190.188,128.535 196.723,128.535C203.259,128.535 207.021,124.545 207.021,117.098L207.021,101.556Z",
    style: {
      fill: "rgb(0,84,120)",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,10.1933,11.7314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.396,128.079L221.196,128.079L221.196,105.128L221.272,105.128L230.049,128.079L233.773,128.079L242.551,105.128L242.627,105.128L242.627,128.079L246.427,128.079L246.427,101.556L240.157,101.556L231.987,123.595L223.665,101.556L217.396,101.556L217.396,128.079Z",
    style: {
      fill: "rgb(0,84,120)",
      fillRule: "nonzero"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMekoLogo);
export default __webpack_public_path__ + "static/media/MEKO_LOGO.9aae21a3f92d7629be3064f699c8faf0.svg";
export { ForwardRef as ReactComponent };